(() => {
  if (!('IntersectionObserver' in window) || !Element.prototype.animate || window.Shopify?.designMode) return;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const seen = new WeakSet();
  const animations = new Set();
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(({ target, isIntersecting }) => {
      if (!isIntersecting) return;
      observer.unobserve(target);
      if (reduced.matches || !target.complete || !target.naturalWidth) return;
      const animation = target.animate([
        { opacity: 0.25, transform: 'translateY(8px)' },
        { opacity: 1, transform: 'translateY(0)' }
      ], { duration: 450, easing: 'cubic-bezier(.22,.61,.36,1)' });
      animations.add(animation);
      animation.finished.then(() => animations.delete(animation), () => animations.delete(animation));
    });
  }, { threshold: 0.08 });
  function scan(root) {
    root.querySelectorAll('main img').forEach((image) => {
      if (seen.has(image) || image.closest('media-gallery, .card__media, cart-items')) return;
      seen.add(image);
      if (image.getBoundingClientRect().top < window.innerHeight) return;
      observer.observe(image);
    });
  }
  scan(document);
  reduced.addEventListener('change', () => {
    if (reduced.matches) animations.forEach((animation) => animation.cancel());
  });
})();
